import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import domainSettings from "../../dependencies/custom/settings";

export const useAssignments = () => {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterTemplate, setFilterTemplate] = useState(null);

  const fetchAssignments = useCallback(
    async (status, template) => {
      setLoading(true);
      try {
        let url = domainSettings.urls.bot.clearanceAssignments;
        const params = [];

        if (status) params.push(`status=${status}`);
        if (template) params.push(`requirement_template=${template}`);

        if (params.length > 0) {
          url += `?${params.join("&")}`;
        }

        const response = await Utilities.fetchWithAuth(
          "GET",
          url,
          null,
          navigate,
        );

        if (response.ok) {
          setAssignments(response.data.results || response.data || []);
        } else {
          Utilities.showError(response, "Failed to fetch assignments");
        }
      } catch (error) {
        message.error("An error occurred");
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [navigate],
  );

  const fetchTemplates = useCallback(async () => {
    try {
      const response = await Utilities.fetchWithAuth(
        "GET",
        domainSettings.urls.bot.requirementTemplates,
        null,
        navigate,
      );

      if (response.ok) {
        setTemplates(response.data.results || response.data || []);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  }, [navigate]);

  const filteredAssignments = assignments.filter((assignment) => {
    const searchLower = searchText.toLowerCase();
    return (
      assignment.botpc?.toLowerCase().includes(searchLower) ||
      assignment.student_name?.toLowerCase().includes(searchLower) ||
      assignment.student_spc?.toLowerCase().includes(searchLower) ||
      assignment.template_name?.toLowerCase().includes(searchLower)
    );
  });

  return {
    assignments,
    filteredAssignments,
    templates,
    loading,
    searchText,
    setSearchText,
    filterStatus,
    setFilterStatus,
    filterTemplate,
    setFilterTemplate,
    fetchAssignments,
    fetchTemplates,
  };
};
